import { ROUTE_ACCESS } from '@shared/accessPolicy';
import type { RoleId } from '@shared/roles';
import { ROLES } from '@shared/roles';
import { STUDENT_HOME } from '@/config/studentRoutes';

export { ROLES, ROUTE_ACCESS };
export type { RoleId };

// Feature-flag management must remain reachable to super-admins even when
// their own account does not carry its management flag.
export const SUPER_ADMIN_FEATURE_BYPASS: ReadonlySet<string> = new Set([
  '/admin/feature-flags',
]);

export const DEFAULT_REDIRECTS: Record<RoleId, string> = {
  [ROLES.SUPER_ADMIN]: '/admin/class-codes',
  [ROLES.ADMIN]: '/admin/enrollments',
  [ROLES.TEACHER]: '/teacher/class-codes',
  // Students land on Tasks — the "do now" home: today's practice plus teacher
  // homework in one due list.
  [ROLES.USER]: STUDENT_HOME,
  // The affiliate portal is the only route an affiliate can reach, so it is also
  // their landing page — anything else would bounce them through a gate.
  [ROLES.AFFILIATE]: '/affiliate',
};
